import { Injectable, inject } from '@angular/core';
import { EventBusService, EventPayload } from 'src/app/shared/services/event-bus.service';
import { LocumsMarginCalculatorEvents } from '../enums/locums-margin-calculator-events';
import { MarginNotesStore } from './margin-notes.store';

@Injectable({ providedIn: 'root' })
export class MarginNotesReducer {
    private readonly eventBus = inject(EventBusService);
    private readonly marginNotesStore = inject(MarginNotesStore);

    constructor() {
        this.listenToMarginNotesEvent();
    }

    private listenToMarginNotesEvent() {
        this.eventBus.on(LocumsMarginCalculatorEvents.MARGIN_NOTES_CHANGED).subscribe((event: EventPayload) => {
            this.marginNotesStore.updateMarginNotes({ marginNotes: event.payload });
        });
    }
}
